// Every whole-number box in the portal is a text input, not type="number".
// A native number input steps its value when the page is scrolled with the
// pointer over it, so a customer scrolling past "100" silently turns it into
// "99"; its spinner arrows and its acceptance of "e", "-" and "." add nothing a
// count needs. inputMode="numeric" still brings up the numeric keypad on
// mobile, and parseWholeNumberInput keeps the box digits-only.

export const WHOLE_NUMBER_INPUT_PROPS = {
  type: 'text',
  inputMode: 'numeric',
  pattern: '[0-9]*',
  autoComplete: 'off',
} as const;

// Reads a whole-number box's raw text. Returns the number, null for an empty
// box, or undefined when the edit is not a whole number — the caller then
// ignores the change so the controlled input keeps its previous value, which
// refuses the keystroke instead of truncating "20.5" to 20 or 205. Thousands
// separators and whitespace from a paste are tolerated.
export function parseWholeNumberInput(raw: string): number | null | undefined {
  const cleaned = raw.replace(/[\s,]/g, '');
  if (cleaned === '') return null;
  if (!/^\d+$/.test(cleaned)) return undefined;
  const n = Number(cleaned);
  return Number.isSafeInteger(n) ? n : undefined;
}
